import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceNumber'
})
export class ReplaceNumberPipe implements PipeTransform {

  transform(value: string): string | number {
    if (!value) {
      return 0;
    }

    const partes = value.split('.');
    const parteInteira = partes.shift().replace(/,/g, '.');

    return partes.length > 0
      ? `${parteInteira},${partes.join('')}`
      : parteInteira;
  }

}
